import {
  useTranslate,
  IResourceComponentsProps,
  useShow,
} from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";
import { BooleanField, DateField } from "@pankod/refine-antd";

import { IServiceAccount } from "interfaces";

const { Title, Text } = Typography;

export const ServiceAccountShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { queryResult } = useShow<IServiceAccount>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{t("serviceAccount.fields.name")}</Title>
      <Text>{record?.name}</Text>

      <Title level={5}>{t("serviceAccount.fields.client_id")}</Title>
      <Text copyable>{record?.client_id}</Text>

      <Title level={5}>{t("serviceAccount.fields.is_active")}</Title>
      <BooleanField value={record?.is_active} />

      <Title level={5}>{t("parameter.fields.created_at")}</Title>
      <DateField value={record?.created_at} format="LLL" />

      <Title level={5}>{t("parameter.fields.updated_at")}</Title>
      <DateField value={record?.updated_at} format="LLL" />
    </Show>
  );
};
